import { View, VStack } from "@gluestack-ui/themed";
import { NewTransactionInstallmentsController } from "./controller";
import { Text } from "@repo/core/components/core/Text";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { Button } from "@repo/core/components/core/Button";
import { InstallmentsList } from "@repo/core/components/layout/InstallmentsList";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const NewTransactionInstallments = () => {
  const {
    handleBack,
    isMobile,
    control,
    handleOnSubmitForm,
    installmentOptions,
    selectedInterestType,
    handleInterestTypeChange,
    isFetching,
    selectedInstallmentId,
    handleInstallmentChange,
    title,
    handleOnCancel
  } = NewTransactionInstallmentsController();

  return (
    <Scaffolds.Root
      showHeader={false}
      statusBarVariant={StatusBarVariantEnum.STORE_SELECT}
    >
      <Scaffolds.StoreSelect title={title} onBackPress={handleBack}>
        <Scaffolds.Form
          showHeader={false}
          footerContent={
            <View
              w="$full"
              gap="$4"
              flexDirection={!isMobile ? "row-reverse" : "column"}
              pt={isMobile ? "$0" : "$12"}
              px="$4"
              pb="$4"
              justifyContent="flex-end"
            >
              <Button
                flex={isMobile ? undefined : 1}
                size="xl"
                action="secondary"
                text="Continuar"
                onPress={handleOnSubmitForm}
                isDisabled={selectedInstallmentId === null}
              />
              <Button
                flex={isMobile ? undefined : 1}
                variant="outline"
                action="negative"
                size="xl"
                text="Cancelar"
                onPress={handleOnCancel}
              />
            </View>
          }
        >
          <VStack flex={1} gap={24} px="$4">
            <Text fontSize="$lg">Selecione o parcelamento</Text>

            <InputControlled
              control={control}
              name="purchaseValue"
              size="md"
              returnKeyType="next"
              label="Valor da Compra"
              isRequired
              isCurrency
              isBigInput
              isDisabled
            />

            <InstallmentsList
              isFetching={isFetching}
              installmentOptions={installmentOptions}
              selectedInterestType={selectedInterestType}
              selectedInstallmentId={selectedInstallmentId}
              onInstallmentChange={handleInstallmentChange}
              onInterestTypeChange={handleInterestTypeChange}
            />
          </VStack>
        </Scaffolds.Form>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
};

export default NewTransactionInstallments;
